import { render, staticRenderFns } from "./UserSubscriptionList.vue?vue&type=template&id=50694167"
import script from "./UserSubscriptionList.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports